import { Component, OnInit } from '@angular/core';
import { AngularFirestoreCollection, AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Season } from '../../models';
import { EcomicService } from '../../service/comics/ecomic.service';
declare const swal: any;
declare var $: any;

@Component({
  selector: 'app-wis-seasons',
  templateUrl: './wis-seasons.component.html',
  styleUrls: ['./wis-seasons.component.css']
})
export class WisSeasonsComponent implements OnInit {

  WISSeasonsColl: AngularFirestoreCollection<Season>;
  WISseasons: Observable<Season[]>;
  status: any = 'All';
  series: any = 'All';
  seriesdata: any;
  showseries: any = false;
  id:any;
  constructor(private afs: AngularFirestore, private ecomicService: EcomicService) { }

  async ngOnInit() {
    const seriesdata = await this.ecomicService.getWISSeasons();
    seriesdata.subscribe(data => {
      this.seriesdata = data;
      this.showseries = true;
    });
    this.filterseasons();
  }
  filterseasons() {
    const key = this.status != 'All' ? 'status' : 'comic_series';
    const value = this.status != 'All' ? this.status : this.series ;
    this.WISSeasonsColl = this.afs.collection('WISSeason', res => {
    if (this.status == 'All' && this.series == 'All') {
      return res.orderBy('createdAt', 'desc');
    } else {
      return res.orderBy('createdAt', 'desc').where(key, '==', value);
    }
    });
    this.WISseasons = this.WISSeasonsColl.valueChanges();
  }
  delete(id) {
    this.id = id;
    $("#DeleteModal").modal();
  }
  deletedata() {
    console.log("sthbjb")
    $('#DeleteModal').modal('hide');
        this.afs.doc('/WISSeason/'+this.id).delete().then(function () {  
          swal('Deleted!', 'Your Season has been deleted.', 'success');
        }).catch(function(error){
          swal('Error!', error, 'error');
          console.error("error in removing document:",error);
        });
     
  }

}



// WEBPACK FOOTER //
// ./src/app/wis/wis-seasons/wis-seasons.component.ts